/* FilterStep.jsx */
import React, { useEffect, useMemo, useRef, useState } from "react";
import OuterDraggable from "react-draggable";
import { CA_RECOMMENDATION_ELEMENTS } from "../../constants";
import actions from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../common/components/Loader";
const FilterStep = ({
    isView = false,
    isSkeletonView = false,
    selectedElements,
    filter,
    setFilter,
    filterData,
    setFilterData,
    filterDataName,
    setFilterDataName,
    getParamsForMasterFilter,
    ...props
}) => {
    const [transform, setTransform] = useState({ left: 0, top: 0 });
    const [showDropdown, setShowDropdown] = useState(false);
    const { masterFilterList: dropDownData } = useSelector(state => state.smartChartReducer);
    const dispatch = useDispatch();
    const [loadingNext, setLoadingNext] = useState(false);

    const getFilter = item => {
        dispatch(actions.getSmartChartMasterFilterDropDown(item.key, item.key, getParamsForMasterFilter(item.paramKey)));
    };

    const handleDrag = (e, ui) => {
        const { x, y } = ui;
        setTransform({ left: x, top: y });
    };

    const onNext = async () => {
        setLoadingNext(true);
        const promises = [];

        CA_RECOMMENDATION_ELEMENTS?.filter(elem => selectedElements?.column?.includes(elem.key))
            ?.filter(elem => elem.hasFilter)
            ?.forEach(item => {
                if (!filterData[item.paramKey]?.length) {
                    const promise = dispatch(actions.getSmartChartMasterFilterDropDown(item.key, item.key, getParamsForMasterFilter(item.paramKey)))
                        .then(response => {
                            const options = response?.data?.data || dropDownData?.[item.key]?.[item.key] || [];
                            setFilterData(prev => ({ ...prev, [item.paramKey]: options.map(opt => opt.id) }));
                            setFilterDataName(prev => ({ ...prev, [item.label]: options.map(opt => opt.name) }));
                            setFilter(prev => ({ ...prev, [item.key]: options }));
                        })
                        .catch(err => console.error(`Error fetching ${item.label}`, err));

                    promises.push(promise);
                }
            });
        if (selectedElements.column.includes("recomtype") && !filterData["responsibility_ids"]?.length) {
            const p = dispatch(
                actions.getSmartChartMasterFilterDropDown("responsibility", "responsibility", getParamsForMasterFilter("responsibility_ids"))
            ).then(res => {
                const opts = res.data.data || [];
                setFilterData(prev => ({ ...prev, responsibility_ids: opts.map(o => o.id) }));
                setFilterDataName(prev => ({ ...prev, Responsibility: opts.map(o => o.name) }));
                setFilter(prev => ({ ...prev, responsibility: opts }));
            });
            promises.push(p);
        }
        await Promise.all(promises);
        setLoadingNext(false);
        props.onNext();
    };

    const filteredElements = useMemo(() => {
        const renderedParents = new Set();
        const elementsToRender = [];

        CA_RECOMMENDATION_ELEMENTS?.filter(elem => selectedElements?.column?.includes(elem.key) && elem.hasFilter)?.forEach(item => {
            const parentItems = [];

            if (item.parentFilters?.length) {
                item.parentFilters.forEach(parentKey => {
                    if (!selectedElements.column.includes(parentKey) && !renderedParents.has(parentKey)) {
                        const parentItem = CA_RECOMMENDATION_ELEMENTS.find(e => e.key === parentKey);
                        if (parentItem) {
                            parentItems.push(parentItem);
                            renderedParents.add(parentKey);
                        }
                    }
                });
            }

            elementsToRender.push({ item, parentItems });
        });
        if (selectedElements.column.includes("recomtype")) {
            elementsToRender.push({
                item: {
                    key: "responsibility",
                    label: "Responsibility",
                    paramKey: "responsibility_ids",
                    hasFilter: true
                },
                parentItems: []
            });
        }

        return elementsToRender;
    }, [selectedElements]);

    return (
        <React.Fragment>
            <div className="modal modal-region modal-view reco-view-mdl column-setting-modal" id="modalId" style={{ display: "block" }} tabIndex="-1">
                <div className="modal-dialog" role="document">
                    <OuterDraggable handle=".draggable" cancel=".not-draggable" onDrag={handleDrag}>
                        <div className="modal-content outerModal_draggable" style={transform}>
                            <div className="modal-header draggable d-flex justify-content-between align-items-center">
                                <h5 className="modal-title" id="exampleModalLabel">
                                    <div className="txt-hed">Filter Fields</div>
                                </h5>
                                <div className="d-flex align-items-center">
                                    <span className="step-indicator mr-2">Step 1/2</span>
                                    <button type="button" className="close not-draggable" onClick={props.onCancel}>
                                        <span aria-hidden="true">
                                            <img src="/img/close.svg" alt="close" />
                                        </span>
                                    </button>
                                </div>
                            </div>
                            <div className="modal-body region-otr">
                                <div className="alert alert-info mb-3">
                                    You can apply filters to refine your selection or click <strong>Next</strong> to include all options.
                                </div>
                                {/* Replace this dummy content with your actual filter UI */}
                                <div className="filter-content" style={{ minHeight: 500 }}>
                                    {filteredElements.map(({ item, parentItems }) => (
                                        <React.Fragment key={item.key}>
                                            {parentItems?.map(parentItem => (
                                                <DropdownFilter
                                                    key={parentItem.key}
                                                    item={parentItem}
                                                    showDropdown={showDropdown}
                                                    setShowDropdown={setShowDropdown}
                                                    filterData={filterData}
                                                    setFilterData={setFilterData}
                                                    filterDataName={filterDataName}
                                                    setFilterDataName={setFilterDataName}
                                                    filter={filter}
                                                    setFilter={setFilter}
                                                    getFilter={getFilter}
                                                    dropdownData={dropDownData?.[parentItem.key]?.[parentItem.key]}
                                                    dropdownLoading={dropDownData?.[parentItem.key]?.loading}
                                                    isView={isView}
                                                />
                                            ))}
                                            <DropdownFilter
                                                item={item}
                                                showDropdown={showDropdown}
                                                setShowDropdown={setShowDropdown}
                                                filterData={filterData}
                                                setFilterData={setFilterData}
                                                filterDataName={filterDataName}
                                                setFilterDataName={setFilterDataName}
                                                filter={filter}
                                                setFilter={setFilter}
                                                getFilter={getFilter}
                                                dropdownData={dropDownData?.[item.key]?.[item.key]}
                                                dropdownLoading={dropDownData?.[item.key]?.loading}
                                                isView={isView}
                                            />
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className="col-md-12 p-0 mt-4 text-right btnOtr d-flex">
                                    <div className="tot-btr">
                                        <button
                                            type="button"
                                            onClick={props.onCancel}
                                            className="btn btn-secondary btnClr col-md-3 mr-1"
                                            data-dismiss="modal"
                                        >
                                            Cancel
                                        </button>
                                        <button type="button" onClick={onNext} disabled={loadingNext} className="btn btn-primary btnRgion btn-wid">
                                            {loadingNext ? (
                                                <span>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                </span>
                                            ) : (
                                                "Next"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </OuterDraggable>
                </div>
            </div>
        </React.Fragment>
    );
};

const DropdownFilter = ({
    item,
    isView = false,
    isSkeletonView = false,
    showDropdown,
    dropdownData = [],
    dropdownLoading,
    setShowDropdown,
    filterData,
    setFilterData,
    filterDataName,
    setFilterDataName,
    filter,
    setFilter,
    getFilter
}) => {
    const [filterSearch, setFilterSearch] = useState("");
    const [tempFilterData, setTempFilterData] = useState({});
    const [tempFilterDataName, setTempFilterDataName] = useState({});

    const renderFilteredList = () => {
        let filteredList = [];
        if (dropdownData?.length) {
            filteredList = filterSearch?.trim()?.length
                ? dropdownData.filter(
                      item =>
                          item.name?.toString()?.toLowerCase()?.includes(filterSearch?.toLocaleLowerCase()) ||
                          item?.trade?.toString()?.toLowerCase()?.includes(filterSearch?.toLocaleLowerCase())
                  )
                : dropdownData;
        }

        return filteredList;
    };

    const handleClickFilterDropdown = item => {
        setFilterSearch("");
        if (showDropdown === item.key) {
            setShowDropdown("");
        } else {
            setTempFilterData(prev => ({ ...prev, [item.paramKey]: filterData?.[item.paramKey] || [] }));
            setTempFilterDataName(prev => ({ ...prev, [item.label]: filterDataName?.[item.label] || [] }));
            setShowDropdown(item.key);
            getFilter(item);
        }
    };

    const handleSelectDropdown = (item, data) => {
        let selectedFilter = tempFilterData[item.paramKey] ? [...tempFilterData[item.paramKey]] : [];
        let selectedFilterName = tempFilterDataName[item.label] ? [...tempFilterDataName[item.label]] : [];
        if (selectedFilter?.includes(data.id)) {
            selectedFilter = selectedFilter.filter(id => id !== data.id);
            selectedFilterName = selectedFilterName.filter(item => item !== data?.name);
        } else {
            selectedFilter.push(data.id);
            selectedFilterName.push(data?.name);
        }
        setTempFilterData({ ...tempFilterData, [item.paramKey]: selectedFilter });
        setTempFilterDataName({ ...tempFilterDataName, [item.label]: selectedFilterName });
    };

    const handleSelectAll = (item, isChecked) => {
        if (isChecked) {
            const allIds = dropdownData?.map(item => item.id) || [];
            const allNames = dropdownData?.map(item => item.name) || [];
            setTempFilterData(prev => ({ ...prev, [item.paramKey]: allIds }));
            setTempFilterDataName(prev => ({ ...prev, [item.label]: allNames }));
        } else {
            setTempFilterData(prev => ({ ...prev, [item.paramKey]: [] }));
            setTempFilterDataName(prev => ({ ...prev, [item.label]: [] }));
        }
    };

    const handleDropdownAction = (item, action) => {
        if (action === "submit") {
            setFilterData(prev => ({ ...prev, [item.paramKey]: tempFilterData[item.paramKey] || [] }));
            setFilterDataName(prev => ({ ...prev, [item.label]: tempFilterDataName[item.label] || [] }));
            const selectedItems = dropdownData.filter(elem => tempFilterData[item.paramKey]?.includes(elem.id));
            setFilter(prev => ({ ...prev, [item.key]: selectedItems || [] }));
        } else {
            setTempFilterData(prev => ({ ...prev, [item.paramKey]: filterData[item.paramKey] || [] }));
            setTempFilterDataName(prev => ({ ...prev, [item.label]: filterDataName[item.label] || [] }));
        }
        setShowDropdown("");
    };
    const fil = item.key;

    return (
        <div className={`otr-form col-md-12 p-0 d-flex mt-2`}>
            <div className={`selct-otr col-md-12 p-0`}>
                <div className="grid-inner d-flex category-selc-drp">
                    <div
                        className={`grid-box position-relative ${filterData[item.paramKey]?.length ? "bg-th-filtered" : ""}`}
                        onClick={() => handleClickFilterDropdown(item)}
                    >
                        <div className={`dropdown-container ${showDropdown === fil ? "dropdown-open" : ""} `}>
                            <div className="dropdown-toggle click-dropdown">
                                {item.label}
                                <span className="close-reg">
                                    <i className="fas fa-chevron-down" />
                                </span>
                            </div>
                            {showDropdown === fil && (
                                <div className={`dropdown-menu p-0 ${showDropdown === fil ? "dropdown-active" : ""}`}>
                                    <div className="drop-filtr" onClick={e => e.stopPropagation()}>
                                        <div className="col-md-12 p-0 border-bottom pt-1">
                                            <span className="dropdown-item build_search_drp">
                                                <input
                                                    type="search"
                                                    placeholder="Search..."
                                                    value={filterSearch}
                                                    onChange={e => {
                                                        let value = e.target.value;
                                                        setFilterSearch(value);
                                                    }}
                                                />
                                                <i className="fas fa-times cursor-pointer cls-close" onClick={() => setFilterSearch("")} />
                                            </span>
                                        </div>
                                        <div className="col-md-12 p-0 border-bottom pt-1">
                                            <div className="dropdown-item select_section_outer">
                                                <label className={`container-check ${isView || isSkeletonView ? "cursor-disabled" : ""}`}>
                                                    Select All
                                                    <input
                                                        type="checkbox"
                                                        checked={
                                                            dropdownData?.length > 0 && tempFilterData[item.paramKey]?.length === dropdownData.length
                                                        }
                                                        onChange={e => handleSelectAll(item, e.target.checked)}
                                                        disabled={isView || isSkeletonView}
                                                    />
                                                    <span className={`checkmark ${isView || isSkeletonView ? "cursor-disabled" : ""}`}></span>
                                                </label>
                                                <button
                                                    className={`clear-btn-selection ${isView || isSkeletonView ? "cursor-disabled" : ""}`}
                                                    onClick={() => {
                                                        setTempFilterData(prev => ({ ...prev, [item.paramKey]: [] }));
                                                        setTempFilterDataName(prev => ({ ...prev, [item.paramKey]: [] }));
                                                    }}
                                                    disabled={isView || isSkeletonView}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </div>
                                        {dropdownLoading ? (
                                            <div className="col-md-12 p-4">
                                                <Loader />
                                            </div>
                                        ) : (
                                            <>
                                                <div className="col-md-12 p-0 slt-ara border-bottom dpr-wide-txt">
                                                    {dropdownData
                                                        ?.filter(fi => tempFilterData[item.paramKey]?.includes(fi.id))
                                                        ?.map(data => (
                                                            <span className="dropdown-item" key={data.id}>
                                                                <label
                                                                    className={`container-check ${isView || isSkeletonView ? "cursor-disabled" : ""}`}
                                                                >
                                                                    <span
                                                                        className="text-short"
                                                                        data-tip={
                                                                            data.name?.length + data?.description?.length > 25
                                                                                ? `${data.name} ${data.description ? `(${data.description})` : ""}`
                                                                                : null
                                                                        }
                                                                        data-effect="solid"
                                                                        data-for="smart-chart-master-filter"
                                                                        data-place="left"
                                                                        data-background-color="#007bff"
                                                                        data-delay-show="500"
                                                                    >
                                                                        {data.trade ? `${data.trade}-` : ""}
                                                                        {data.name} {data.description ? `(${data.description})` : ""}
                                                                    </span>
                                                                    {data.count ? <span className="count-num"> ({data.count})</span> : null}
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={true}
                                                                        onChange={() => handleSelectDropdown(item, data)}
                                                                        disabled={isView || isSkeletonView}
                                                                    />
                                                                    <span
                                                                        className={`checkmark ${isView || isSkeletonView ? "cursor-disabled" : ""}`}
                                                                    />
                                                                </label>
                                                            </span>
                                                        ))}
                                                </div>
                                                {renderFilteredList()?.filter(fi => !tempFilterData[item.paramKey]?.includes(fi.id))?.length ? (
                                                    <div className="col-md-12 p-0 slt-ara overflw-ht dpr-wide-txt">
                                                        {renderFilteredList()
                                                            ?.filter(fi => !tempFilterData[item.paramKey]?.includes(fi.id))
                                                            ?.map(data => (
                                                                <span className="dropdown-item" key={data.id}>
                                                                    <label
                                                                        className={`container-check ${
                                                                            isView || isSkeletonView ? "cursor-disabled" : ""
                                                                        }`}
                                                                    >
                                                                        <span
                                                                            className="text-short"
                                                                            data-tip={
                                                                                data.name?.length + data?.description?.length > 25
                                                                                    ? `${data.name} ${
                                                                                          data.description ? `(${data.description})` : ""
                                                                                      }`
                                                                                    : null
                                                                            }
                                                                            data-effect="solid"
                                                                            data-for="smart-chart-master-filter"
                                                                            data-place="left"
                                                                            data-background-color="#007bff"
                                                                            data-delay-show="500"
                                                                        >
                                                                            {data.trade ? `${data.trade}-` : ""}
                                                                            {data.name} {data.description ? `(${data.description})` : ""}
                                                                        </span>
                                                                        {data.count ? <span className="count-num"> ({data.count})</span> : null}
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={false}
                                                                            onChange={() => handleSelectDropdown(item, data)}
                                                                            disabled={isView || isSkeletonView}
                                                                        />
                                                                        <span
                                                                            className={`checkmark ${
                                                                                isView || isSkeletonView ? "cursor-disabled" : ""
                                                                            }`}
                                                                        />
                                                                    </label>
                                                                </span>
                                                            ))}
                                                    </div>
                                                ) : !dropdownData?.length ? (
                                                    <div className={`col-md-12`}>
                                                        {renderFilteredList("trade")?.filter(fi => !tempFilterData[item.paramKey]?.includes(fi.id))
                                                            ?.length === 0
                                                            ? "No data Found"
                                                            : ""}
                                                    </div>
                                                ) : null}
                                            </>
                                        )}
                                        <div className="col-md-12 drp-btn">
                                            <button
                                                type="button"
                                                className={`btn btn-primary ${isView || isSkeletonView ? "cursor-disabled" : ""}`}
                                                onClick={() => handleDropdownAction(item, "submit")}
                                                disabled={isView || isSkeletonView}
                                            >
                                                ok
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-primary btnClr ml-2"
                                                onClick={() => handleDropdownAction(item, "cancel")}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterStep;
